import type { ItineraryItem } from '@/services/itinerary';
import type { Trip } from '@/services/trips';
import { resolveItemStartInstant } from '@/utils/tripItemSchedule';

/** Human-readable date + wall-clock label in the trip destination timezone. */
export const formatTripItemScheduleLabel = (
  item: ItineraryItem,
  timeZone: string,
  trip?: Trip,
  options?: { includeDate?: boolean },
): string | null => {
  const includeDate = options?.includeDate ?? true;
  const instant = resolveItemStartInstant(item, timeZone, trip);
  const parts: string[] = [];

  if (includeDate) {
    parts.push(
      instant.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        timeZone,
      }),
    );
  }

  if (item.startTime && item.startTime !== 'flexible') {
    parts.push(
      instant.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        timeZone,
      }),
    );
  }

  return parts.length ? parts.join(' • ') : null;
};
